
import moment from 'moment/moment';
import { RANGE_TIME, REGION, REGION_EXTEND_TYPE, RANGE_TIME_EXTEND_TYPE } from '@/pages/intelligence/components/Filter/FilterBase/_config';

export const DEFAULT_FORM_VALUE = {
  [RANGE_TIME]: {
    type: 'date',
    value: ['', ''],
  },
  [REGION]: {
    regions: [],
    markets: ['global'],
    type: 'market',
  },
}


export const STATIC_FILTER_CONFIGS = {
  RANGE_TIME: {
    type: RANGE_TIME,
    key: RANGE_TIME,
    calendarType: 'date',
    showSelectType: true,
    showShortcut: false,
    default: [],
  },
  REGION: {
    extendFilterType: REGION_EXTEND_TYPE.common,
    key: REGION,
    default: DEFAULT_FORM_VALUE[REGION],
    visible: 1,
    options: [],
  },
}